import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { CartPoLineComponent } from './cart-po-line.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SimpleToggleModule } from '../../../../../../components/form-elements/simple-toggle/simple-toggle.module';

@NgModule({
  declarations: [CartPoLineComponent],
  imports: [CommonModule, I18nModule, ReactiveFormsModule, SimpleToggleModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CartPOLine: {
          component: CartPoLineComponent,
        },
      },
    }),
  ],
})
export class CartPoLineModule {}
